import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Main from "./components/Main";
import Home from "./components/Home";
import LogIn from "./components/LogIn";
import Register from "./components/Register";
import Privet from "./routes/Privet";
import Courses from "./components/course/Courses";
import Card from "./components/course/Card";
import Topic from "./components/course/Topic";
import Premium from "./components/course/Premium";
import FAQ from "./components/course/FAQ";
import Error from "./components/Error";
import Blog from "./components/Blog/Blog";
import { Toaster } from "react-hot-toast";

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Main></Main>,
      children: [
        {
          path: "/courses",
          element: <Courses></Courses>,
          loader: () => fetch(" https://server-app-gilt.vercel.app/courses"),
        },
        {
          path: "/courses/:id",
          element: <Card></Card>,
          loader: ({ params }) =>
            fetch(` https://server-app-gilt.vercel.app/courses/${params.id}`),
        },
        
        {
          path: "/",
          element: <Home></Home>,
        },
        {
          path: "/blog",
          element: <Blog></Blog>,
        },
        {
          path: "/logIn",
          element: <LogIn></LogIn>,
        },
        {
          path: "/faq",
          element: <FAQ></FAQ>,
        },
        {
          path: "/courses/:id/premium",
          element: 
            <Privet>
              <Premium></Premium>
            </Privet>,
          loader: ({ params }) =>
            fetch(` https://server-app-gilt.vercel.app/courses/${params.id}/premium`),
        },
        {
          path: "/register",
          element: <Register></Register>,
        },
      ],
    },
    {
      path: '*',
      element: <Error></Error>
    }
  ]);

  return (
    <div className="App">
      <RouterProvider router={router}></RouterProvider>
      <Toaster></Toaster>
    </div>
  );
}

export default App;
